<template>
  <v-dialog persistent v-model="dialog" max-width="800px">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
        small
        class="ma-0"
      >
        <v-icon color="primary" small>edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="headline primary"
        primary-title
      >
        <span class="white--text">Unternehmen bearbeiten</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs3>
                Logo:
              </v-flex>
              <v-flex xs6>
                <image-selector v-if="localCompany" v-model="newImage" :url="localCompany.image" :width="200"/>
              </v-flex>
              <v-flex xs3>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Titel"
                  v-model="localCompany.title"
                  :disabled="loading"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Email"
                  required
                  v-model="localCompany.email"
                  :rules="emailRules"
                  :disabled="loading"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Abbrechen</v-btn>
        <v-btn color="primary" @click.native="update()" :loading="loading" :disabled="!valid">
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions} from 'vuex';
  import ImageSelector from '@/components/ImageSelector';

  export default {
    name: 'DlgCompanyUpdate',
    components: {ImageSelector},
    props: ['company'],
    data() {
      return {
        dialog: false,
        localCompany: {},
        newImage: null,
        loading: false,
        valid: true,
        emailRules: [
          (v) => !!v || 'E-mail ist ein Pflichtfeld',
          (v) => /.+@.+/.test(v) || 'E-mail ist ungültig',
        ],
        genders: [
          {
            text: 'Weiblich',
            value: 'female',
          },
          {
            text: 'Männlich',
            value: 'male',
          },
        ],
      };
    },
    methods: {
      ...mapActions({
        updateCompany: 'admin/companies/update',
        uploadImage: 'admin/companies/uploadImage',
        readCompanies: 'admin/companies/read',
      }),
      async update() {
        if (this.$refs.form.validate()) {
          this.loading = true;

          if (this.newImage) {
            this.localCompany.image = await this.uploadImage({image: this.newImage});
          }

          this.updateCompany(this.localCompany).then((success) => {
            this.loading = false;
            if (success) {
              this.readCompanies();
              this.localCompany = {};
              this.dialog = false;
            }
          });
        }
      },
    },
    watch: {
      dialog() {
        this.localCompany = JSON.parse(JSON.stringify(this.company));
        this.companyImage = this.localCompany.image;
      },
    },
  };
</script>

<style scoped>

</style>
